const types = {
  SHOW_TOAST: 'show_toast',
  HIDE_TOAST: 'hide_toast',
  SHOW_LOADING: 'show_loading',
  HIDE_LOADING: 'hide_loading'
}

const state = {
  toast: {isShow: false},
  isLoading: false
}

const mutations = {
  [types.SHOW_TOAST] (state, payload) {
    state.toast.isShow = true
    state.toast.msg = payload.msg
    state.toast.type = payload.type
  },
  [types.HIDE_TOAST] (state) {
    state.toast.isShow = false
  },
  [types.SHOW_LOADING] (state) {
    state.isLoading = true
  },
  [types.HIDE_LOADING] (state) {
    state.isLoading = false
  }
}

const actions = {
  showToast: ({commit}, payload) => {
    commit(types.SHOW_TOAST, payload)
  },
  hideToast: ({commit}) => {
    commit(types.HIDE_TOAST)
  },
  showLoading: ({commit}) => {
    commit(types.SHOW_LOADING)
  },
  hideLoading: ({commit}) => {
    commit(types.HIDE_LOADING)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/global/global.js